export const ROLE = {
    ROLE_USER_NORMAL: 0,
    ROLE_USER_ADMIN: 1
};